module.exports = __webpack_public_path__ + "static/img/shopHeaderBj.2cd5260.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopHeaderBj.png
// module id = GWcj
// module chunks = 18